import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import DashboardLayout from "@/components/layout/DashboardLayout";
import Login from "@/pages/Login";
import Overview from "@/pages/Overview";
import Leads from "@/pages/Leads";
import Kanban from "@/pages/Kanban";
import Members from "@/pages/Members";
import LinkedInInbox from "@/pages/LinkedInInbox";
import Upload from "@/pages/Upload";
import FollowUps from "@/pages/FollowUps";
import Analytics from "@/pages/Analytics";
import Guide from "@/pages/Guide";
import Products from "@/pages/Products";
import TeamPerformance from "@/pages/TeamPerformance";
import Teams from "@/pages/Teams";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Overview />} />
              <Route path="leads" element={<Leads />} />
              <Route path="kanban" element={<Kanban />} />
              <Route path="upload" element={<Upload />} />
              <Route path="followups" element={<FollowUps />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="team" element={<TeamPerformance />} />
              <Route path="teams" element={<Teams />} />
              <Route path="guide" element={<Guide />} />
              <Route path="products" element={<Products />} />
              <Route
                path="members"
                element={
                  <ProtectedRoute requireAdmin>
                    <Members />
                  </ProtectedRoute>
                }
              />
              <Route
                path="linkedin"
                element={<LinkedInInbox />}
              />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          theme="light"
          duration={2500}
          toastOptions={{
            style: {
              background: "rgba(255,255,255,0.95)",
              border: "1px solid #ecebe4",
              color: "#1e1e22",
              backdropFilter: "blur(20px)",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
